<template>
  <div v-show="isModalVisible">
    <transition name="slide">
      <div class="modal-mask" @click="hide">
        <div class="modal-dialog modal-dialog-slideout modal-lg" @click.stop>
          <div class="modal-content p-2">
            <div class="modal-header px-4 pt-2 pb-0">
              <div class="" style="width: 100%;">
                <a href="javascript:void(0);" @click="hide" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                <button type="button" class="close float-right" @click="hide">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="clearfix"></div>
              </div>
            </div>
            <div class="modal-body">
              <div class="modal_reps_to_review d-none-">
                <div class="row mb-2 mt-3">
                  <div class="col-12">
                    <div class="h3 d-inline mx-4 pl-2 add-form-heading">{{ formName }}</div>
                  </div>
                </div>

                <div v-if="formId > 0" class="mx-4 px-3">
                  <vue-form-generator :schema="formData" :model="model" :options="formOptions" ref="vfg"></vue-form-generator>
                </div>
                <div class="submit-wrapper text-center margin-bottom-15" style="margin-top: 15px;">
                  <button type="submit" class="btn ma-blue-btn  font-weight-bold rounded-pill px-5" @click="onSubmit">Submit</button>
                </div>





              </div>
            </div>

            <div class="modal-footer"></div>
          </div>
        </div>
      </div>
    </transition>




  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'

Vue.use(VueFormGenerator)

export default {
  props: ['isModalVisible'],
  data() {
    return {
      model: {},
      userId: '',
      formId: '',
      formData: {},
      formName: '',
      userFullName: '',      
      formOptions: {
        validateAfterLoad: true,
        validateAfterChanged: true,
        validateAsync: true
      }
    }
  },


  computed: {
  },

  methods: {
    hide(flag = 0) {
      this.$emit('closeMenteeEditFormModal', flag);
    },
      getFormData(formId, userId) {
        this.formId = formId;
        this.userId = userId;
        axios.get('/user_fullname', {

        })
        .then(response =>  {
            this.userFullName = response.data;
        })
        .catch(function(error) {
            console.log(error);
        });
        if (this.$store.state.user_accountid) {
          var formRenderUrl = '/forms-manager/user-render/'+this.formId + '/' + this.userId  + '/' + this.$store.state.user_accountid;
        } else {
          if (store.state.roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
            formRenderUrl = '/forms-manager/user-render/'+this.formId + '/' + this.userId + '/0';
          }
        }

        axios.get(formRenderUrl, {
        })
        .then(response =>  {
          this.formName = response.data.forms.form_name;
          this.formData = {'fields': response.data.fields};
          this.model = response.data.models;
        })
        .catch(function(err) {
          console.log("Come here"+ err);
        });

      },
     onSubmit() {
        var validationPassed = this.$refs.vfg.validate();
        if(validationPassed) {
          if (this.$store.state.user_accountid) {
            var formUpdateUrl = '/forms-manager/update-values/'+this.formId + '/' + this.userId  + '/' + this.$store.state.user_accountid;
          } else if (store.state.roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
            formUpdateUrl = '/forms-manager/update-values/'+this.formId + '/' + this.userId + '/0';
          }
          
          axios(formUpdateUrl,
            {
              method: 'PATCH',
              data: this.model, 
            },
          )
          .then(response => {
            this.hide(1);
          })
          .catch(error => {
             console.log(error) 
          });
       }  
     },     
  },

  components: {

  },
  created() {

  },
  mounted() {

  }
}
</script>

<style scoped>
.back_icon { width: 14px; }
.mentee_title_btn {
  background-color: #b3e6fa;
  padding: 2px 10px;
  border-radius: 8px;
  font-size: 12px;
  color: #2d6074;
  border: 0;
  margin-top: -12px;
}
.progress_step {
  height:10px;
  margin-top: 5px;
}
.panel-title a {
  font-size: 14px;
  color: #002F42 !important;
  font-weight: normal;
  padding-left: 0px;
}


::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .2);
    transition: opacity .3s ease;
    overflow-y: scroll;    
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
@media (min-width: 1200px) {
  .modal-lg {
    width: 690px;
  }
}
@media (min-width: 992px) and (max-width: 1199.98px) {
  .modal-lg {
    width: 690px;
  }
}
.section-title {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 14px;
  padding-left: 10px !important;
}
.add-form-heading {
  font-size: 18px;
  font-weight: bold;
}

</style>      

<style>
.vue-form-generator label {
    display: inline-block;
    margin-bottom: 0.5rem;
    width: 15%;
    float: left;
    font-weight: bold;
    margin: 3px 0px 3px 0px;
    font-size: 11px;
}
.vue-form-generator .field-radios .radio-list label {
    margin-right: 20px;
    font-size: 12px;
    font-weight: normal;
    width: auto;
    min-width: 15%;
}
.vue-form-generator .dropList label {
    float: none;
    font-size: 12px;
}
.vue-form-generator .field-wrap {
    display: inline;
    width: auto;
}
.vue-form-generator .form-group {
    background-color: #FFF;
    border-bottom: 0px solid #E9E9E9;
    margin-bottom: 0;
    padding: 5px 5px 0px 5px;
}
.vue-form-generator .required {
    color: #474444ff;
}
.vue-form-generator input[type="text"] {
  line-height: 17px;
  border-radius: 10px;
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  padding-left: 5px !important;
  border: 1px solid #707070;
  width: 100%;
  font-size: 1rem;
  font-weight: 400;
}
.vue-form-generator .radio-list label {
  width: 100%;
  padding-left: 15px;
}
.vue-form-generator .radio-list input {

}
.vue-form-generator .form-group label {
  width: 100%;
  font-weight: bold;
  font-size: 14px !important;
  font-family: "proxima-nova",sans-serif;
  color: #002F42;
}
.vue-form-generator .field-checklist .combobox {
  line-height: 17px;
  border-radius: 10px;
  display: block;
  width: 100%;
  padding: 0.575rem 0.75rem 0.375rem 0.75rem;
  padding-left: 5px !important;
  border: 1px solid #707070;
  width: 100%;
  font-size: 1rem;
  font-weight: 400;
}
.vue-form-generator .field-checklist .wrapper {
  display: inline;

}
.vue-form-generator input[type="radio"], input[type="checkbox"] {
  accent-color: #00ACEE;
  border: 0;
}
.vue-form-generator .field-radios .radio-list label input[type="radio"] {
  margin-top: 2px !important;
}
.vue-form-generator .dropList {
  margin-top: 5px;
}
.vue-form-generator .field-checklist .dropList .list-row input, .vue-form-generator .field-checklist .listbox .list-row input {
  margin-right: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/mentee/mentee_update_form_new.vue